import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "../CustomModal/Modal";
import { PATHS } from "./../../Constants";
import CustomModal from "./CustomModal/CustomModal";
import ErrorModal from "./ErrorModal/ErrorModal";
import CustomSpinner from "../Spinner/Spinner";
import SettingsAction from "./SettingsAction";
import OtpModal from "./OtpModal/OtpModal";

//constants
import FLAG_SELECTOR_OPTION_LIST from "../../Countries";
import {
  OperationStatus,
  APIResponse,
} from "../../Communication/Constants";

//css
import "./Settings.scss";
import "../../Resources/Styles/fonts.scss";

//reources
import { Strings } from "../../Resources/Strings/i18n";
import CommonUtils from "../../Utils/CommonUtils";
import ic_tick_green from "../../Resources/Images/ic_tick_green.png";
import ic_settings_about_us1 from "../../Resources/Images/ic_settings_about_us1.png";
import ic_settings_contact_us from "../../Resources/Images/ic_settings_contact_us.png";
import ic_settings_faqs from "../../Resources/Images/ic_settings_faqs.png";
import ic_settings_pro_plans from "../../Resources/Images/ic_settings_pro_plans.png";

//material UI
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      custSpinner: false,
      showErrorModal: false,
      errorMessage: "",
      showCustomModal: false,
      callingCode: "+1",
      mobileNumberValue: "",
      mobileNumberError: false,
      mobile: "",
      showAddEmailModal: false,
      showVerifyEmailModal: false,
      emailID: "",
      emailIDError: false,
      email_verification: false,
    };
    this.SettingsAction = new SettingsAction();
  }

  componentDidMount() {
    localStorage.removeItem("selectedAlertId");
    localStorage.removeItem("myState");
    if (
      this.props.inviteTokenInfo &&
      this.props.inviteTokenInfo.isInvitedUser
    ) {
      this.props.history.push("/home")
    }
    if (!this.props.userInfo || !this.props.userInfo.id) {
      this.setState({
        showErrorModal: true,
        errorMessage: Strings("ERROR_INVALID_AUTH_GRANT"),
        //"Session expired or error occurred, please login again!",
      });
    } else {
      this.getProfileDetails();
    }
  }
  getProfileDetails = () => {
    this.setState({custSpinner:true})
    this.SettingsAction.getProfile(
      { userid: this.props.userInfo.id },
      (actionCallback) => {
        if (actionCallback.status === OperationStatus.SUCCESS) {
          this.setState({
            custSpinner:false,
            errorMessage: "",
            mobile: actionCallback.data.data.mobile,
            emailID: actionCallback.data.data.email,
            email_verification: actionCallback.data.data.email_verification,
          });
        } //error handling
        else {
          this.setState({
            custSpinner:false,
            errorMessage: actionCallback.error.errorMessage,
          });
        }
      }
    );
  };

  hideModal = () => {
    this.setState({
      showCustomModal: false,
      mobileNumberError: false,
      showOTPModal: false,
      emailModal: false,
      emailIDError: false,
      mobileNumberValue: "",
      callingCode:"+1"
    });
    this.getProfileDetails()
  };
  findCountry = (CountryArray, CountryData) => {
    const matchedCountries = [];
    CountryArray.forEach((CountryInfo) => {
      let match = false;
      Object.keys(CountryData).forEach((InfoItem) => {
        if (CountryData[InfoItem] === CountryInfo[InfoItem]) {
          match = true;
        }
      });
      if (match) {
        matchedCountries.push(CountryInfo);
      }
    });
    return matchedCountries;
  };
  onMobileChangeHandler = (mobileValue) => {
    let mobileNumberText = String(mobileValue);
    let mobileError = false;
    if (mobileNumberText === "") {
      this.setState({
        mobileNumberValue: mobileNumberText,
        mobileNumberError: false,
        isValid: false,
      });
      mobileError = true;
    } else if (CommonUtils.isValidNumber(mobileNumberText)) {
      const mobileNumberWithCallingCode =
        this.state.callingCode + mobileNumberText;

      if (
        CommonUtils.isMobileWithCallingCodeValid(mobileNumberWithCallingCode)
      ) {
        this.setState({
          mobileNumberValue: mobileNumberText,
          mobileNumberError: false,
          isValid: true,
        });
        mobileError = false;
      } else {
        this.setState({
          mobileNumberValue: mobileNumberText,
          mobileNumberError: true,
          isValid: false,
        });
        mobileError = true;
      }
    } else {
      mobileError = false;
    }
    return mobileError;
  };
  validateMobile = () => {
    let mobileValue = this.onMobileChangeHandler(this.state.mobileNumberValue);
    if (this.state.mobileNumberValue && !mobileValue) {
      let requestObj = {
        mobile: this.state.mobileNumberValue,
        calling_code: this.state.callingCode,
      };
      this.proceedToOtpPage(requestObj);
    } else {
      this.setState({
        mobileNumberError: true,
      });
    }
  };
  validateEmail = () => {
    if (CommonUtils.isEmailValid(this.state.emailID)) {
      let requestObj = {
        email: this.state.emailID,
      };
      this.proceedToOtpPage(requestObj);
    } else {
      this.setState({ emailIDError: true, showAddEmailModal: true });
    }
  };
  VerifyEmail = () => {
    let requestObj = {
      email: this.state.emailID,
    };
    this.proceedToOtpPage(requestObj);
  };
  proceedToOtpPage = (requestObj) => {
    this.setState({ custSpinner: true });
    this.SettingsAction.sendOTP(requestObj, (actionCallback) => {
      if (actionCallback.status === OperationStatus.SUCCESS) {
        this.setState({
          showCustomModal: false,
          errorMessage: "",
          custSpinner: false,
          showOTPModal: true,
        });
      } //error handling
      else if (
        actionCallback.error.errorCode === APIResponse.MOBILE_ALREADY_EXISTS
      ) {
        this.setState({
          showCustomModal: false,
          showErrorModal: true,
          errorMessage: Strings("MOBILE_ALREADY_EXISTS"),
          mobileNumberValue: "",
          callingCode: "+1",
          showOTPModal: false,
          custSpinner: false,
        });
      } else if (
        actionCallback.error.errorCode === APIResponse.EMAIL_VERIFIED_ALREADY
      ) {
        this.setState({
          showCustomModal: false,
          showErrorModal: true,
          errorMessage: Strings("EMAIL_VERIFIED_ALREADY"),
          showOTPModal: false,
          custSpinner: false,
        });
      } else if (
        actionCallback.error.errorCode ===
        APIResponse.REQUEST_FIELD_NOT_PRESENT_OR_INVALID
      ) {
        this.setState({
          showCustomModal: false,
          showErrorModal: true,
          errorMessage: Strings("ERROR_FIELD_NOT_PRESENT_OR_INVALID"),
          mobileNumberValue: "",
          callingCode: "+1",
          showOTPModal: false,
          custSpinner: false,
          emailID: "",
          emailIDError: false,
        });
        this.getProfileDetails();
      }else if (
        actionCallback.error.errorCode === APIResponse.INVALID_MOBILE_NUMBER
      ) {
        this.setState({
          showCustomModal: false,
          showErrorModal: true,
          errorMessage: Strings("ERROR_INVALID_MOBILE_NUMBER"),
          mobileNumberValue: "",
          callingCode: "+1",
          showOTPModal: false,
          custSpinner: false,
        });
      } else if (
        actionCallback.error.errorCode === APIResponse.EMAIL_ALREADY_EXISTS
      ) {
        this.setState({
          showCustomModal: false,
          showErrorModal: true,
          errorMessage: Strings("ERROR_EMAIL_ALREADY_EXISTS"),
          showOTPModal: false,
          custSpinner: false,
          emailID: "",
          emailIDError:false
        });
      } else {
        this.setState({
          emailID: "",
          emailIDError: false,
          showCustomModal: false,
          showErrorModal: true,
          errorMessage: actionCallback.error.errorMessage,
          mobileNumberValue: "",
          callingCode: "+1",
          showOTPModal: false,
          custSpinner: false,
        });
        this.getProfileDetails();
      }
    });
  };

  onMobileFocus = () => {
    this.setState({
      mobileNumberError: false,
    });
  };
  onEmailFocus = () => {
    this.setState({
      emailIDError: false,
    });
  };
  //google sign up
  onSuccessGoogleSignUp = (response, callback) => {
    this.setState({ custSpinner: true, showCustomModal: false });

    this.SettingsAction.verifyGoogleEmail(
      {
        google_token: response.tokenId,
      },
      (actionCallback) => {
        this.setState({ custSpinner: false });
        if (actionCallback.status === OperationStatus.SUCCESS) {
          this.getProfileDetails();
          this.props.history.push(PATHS.SETTINGS);
        } else {
          callback();
          if (
            actionCallback.error.errorCode ===
            APIResponse.EMAIL_VERIFIED_ALREADY
          ) {
            this.setState({
              showErrorModal: true,
              errorMessage: Strings("EMAIL_VERIFIED_ALREADY"),
              showOTPModal: false,
              emailID: "",
              emailIDError: false,
            });
          } else if (
            actionCallback.error.errorCode === APIResponse.INVALID_GOOGLE_TOKEN
          ) {
            this.setState({
              showErrorModal: true,
              errorMessage: Strings("INVALID_GOOGLE_TOKEN"),
              mobileNumberValue: "",
              callingCode: "+1",
              showOTPModal: false,
              emailID: "",
              emailIDError: false,
            });
          } else {
            this.setState({
              showErrorModal: true,
              errorMessage: actionCallback.error.errorMessage,
              showOTPModal: false,
              emailID: "",
              emailIDError: false,
            });
          }
        }
      }
    );
  };
  render() {
    const callingCode = this.state.callingCode;
    const selectedCountry = this.findCountry(FLAG_SELECTOR_OPTION_LIST, {
      id: callingCode,
    })[0];

    let { first_name, last_name } = this.props.userInfo || {};
    let { mobile, emailID, email_verification } = this.state || {};
    first_name = first_name || "";
    last_name = last_name || "";
    mobile = mobile || "";
    emailID = emailID || "";
    email_verification = email_verification || false;

    let full_name =
      (first_name
        ? first_name[0].toUpperCase() + first_name.substring(1)
        : "") +
      " " +
      (last_name ? last_name[0].toUpperCase() + last_name.substring(1) : "");

    return (
      <div className="Settings">
        <CustomSpinner showModal={this.state.custSpinner} />
        {/* error modal */}
        <div>
          {this.state.showErrorModal ? (
            <ErrorModal
              showErrorModal={this.state.showErrorModal}
              errorMessage={this.state.errorMessage}
              history={this.props.history}
              setShowErrorModal={(value) =>
                this.setState({ showErrorModal: value })
              }
            />
          ) : null}
        </div>
        {/* add/verify mobile/email  */}
        {this.state.showCustomModal ? (
          <CustomModal
            showCustomModal={this.state.showCustomModal}
            hideModal={this.hideModal}
            selectedCountry={selectedCountry}
            setCallingCode={(CallingCode) =>
              this.setState({ callingCode: CallingCode })
            }
            setMobileValue={(MobileNumber) =>
              this.setState({ mobileNumberValue: MobileNumber })
            }
            setEmailValue={(email) => this.setState({ emailID: email })}
            mobileNumberValue={this.state.mobileNumberValue}
            mobileNumberError={this.state.mobileNumberError}
            onMobileFocus={this.onMobileFocus}
            emailID={this.state.emailID}
            emailIDError={this.state.emailIDError}
            onEmailFocus={this.onEmailFocus}
            validateOtp={this.validateMobile}
            validateEmail={this.validateEmail}
            emailModal={this.state.showAddEmailModal}
            showVerifyEmailModal={this.state.showVerifyEmailModal}
            sendDirectToOTP={this.VerifyEmail}
            onSuccessGoogleSignUp={this.onSuccessGoogleSignUp}
          />
        ) : null}

        {/* otp modal */}
        {this.state.showOTPModal ? (
          <Modal
            show={this.state.showOTPModal}
            handleClose={this.hideModal}
            parent={"login"}
          >
            {
              <OtpModal
                showVerifyModal={true}
                handleClose={this.hideModal}
                countryCallingCode={this.state.callingCode}
                mobileNumber={this.state.mobileNumberValue}
                closeOtpModal={() => {
                  this.setState({ showOTPModal: false });
                }}
                getProfileDetails={this.getProfileDetails}
                email={this.state.emailID}
                showEmail={!emailID || !email_verification}
              />
            }
          </Modal>
        ) : null}

        <Card className="AccountContainer">
          <div className="heading">
            <CardContent>{Strings("Account").toUpperCase()}</CardContent>
          </div>
          <div className="innerSettingDataVertical">
            <div className="innerHeading">
              <CardContent className="innerHeadingData1">
                {Strings("Name")}
              </CardContent>
              <CardContent className="innerHeadingData2">
                {full_name}
              </CardContent>
            </div>
            <div className="innerHeading">
              <CardContent className="innerHeadingData1">
                {Strings("EmailPlaceHolder")}
              </CardContent>
              <CardContent className="innerHeadingData2">
                {emailID && email_verification ? (
                  <div className="emailWithBtn">
                    {emailID}
                    <img src={ic_tick_green} alt={"ic_tick_green"} />
                  </div>
                ) : emailID && !email_verification ? (
                  <div className="emailWithBtn">
                    <div className="redEmail">{emailID}</div>
                    <Button
                      onClick={() => {
                        this.setState({
                          showCustomModal: true,
                          showVerifyEmailModal: true,
                        });
                      }}
                    >
                      {Strings("verify")}
                    </Button>
                  </div>
                ) : (
                  <Button
                    onClick={() => {
                      this.setState({
                        showCustomModal: true,
                        showAddEmailModal: true,
                      });
                    }}
                    // onClick={this.proceedToOtpPage}
                  >
                    {Strings("Add")}
                  </Button>
                )}
              </CardContent>
            </div>
            <div className="innerHeading">
              <CardContent className="innerHeadingData1">
                {Strings("Phone_Number")}
              </CardContent>
              <CardContent className="innerHeadingData2">
                {mobile ? (
                  <div className="emailWithBtn">
                    {mobile}
                    <img src={ic_tick_green} alt={"ic_tick_green"} />
                  </div>
                ) : (
                  <Button
                    onClick={() => {
                      this.setState({
                        showCustomModal: true,
                        toggleModal: false,
                      });
                    }}
                  >
                    {Strings("Add")}
                  </Button>
                )}
              </CardContent>
            </div>
          </div>
        </Card>

        <Card className="AccountContainer">
          <div className="heading">
            <CardContent>{Strings("AboutUs").toUpperCase()}</CardContent>
          </div>
          <div className="innerSettingDataHorizontal">
            <a
              className="innerHeading"
              onClick={() => {
                window.open(
                  "https://allwellapp.com/free"
                  // "_block"
                );
              }}
            >
              <CardContent className="innerHeadingData1">
                <img src={ic_settings_about_us1} alt="ic_settings_about_us1" />
              </CardContent>
              <CardContent className="innerHeadingData2">
                {Strings("AboutUs")}
              </CardContent>
            </a>
            <a
              className="innerHeading"
              onClick={() => {
                window.open("https://allwellapp.com/free");
              }}
            >
              <CardContent className="innerHeadingData1">
                <img src={ic_settings_faqs} alt="ic_settings_faqs" />
              </CardContent>
              <CardContent className="innerHeadingData2">
                {Strings("FAQS")}
              </CardContent>
            </a>
            <a
              className="innerHeading"
              onClick={() => {
                window.open("https://allwellapp.com/free");
              }}
            >
              <CardContent className="innerHeadingData1">
                <img src={ic_settings_pro_plans} alt="ic_settings_pro_plans" />
              </CardContent>
              <CardContent className="innerHeadingData2">
                {Strings("ProPlans")}
              </CardContent>
            </a>
            <a
              className="innerHeading"
              onClick={() => {
                window.open("https://allwellapp.com/free");
              }}
            >
              <CardContent className="innerHeadingData1">
                <img
                  src={ic_settings_contact_us}
                  alt="ic_settings_contact_us"
                />
              </CardContent>
              <CardContent className="innerHeadingData2">
                {Strings("ContactUsPlaceHolder")}
              </CardContent>
            </a>
          </div>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: CommonUtils.getInvitedTokenInfo(state),
    userList: state.Dashboard.userInfo,
    data: state.CareCircle.data,
    error: state.CareCircle.error,
    alertsData: state.Alert.alertsData,
    invitedUserInfo: state.Dashboard.invitedUserInfo,
    inviteTokenInfo: state.InvitationHandler.accessInfo,
  };
};

export default connect(mapStateToProps)(Settings);

